import moment from 'moment-timezone';
import React from 'react';

import BackButton from '../../../../Buttons/BackButton/BackButton';
import FieldBold from '../../../../Fields/FieldBold/FieldBold';
import utils from '../../../../../services/utils';

import classes from './DetailOneInvoice.module.scss';

const DetailOneInvoice = ({ setInvoiceSelected, invoiceSelected }) => {
  const backStep = () => {
    setInvoiceSelected(null);
  };
  return (
    <>
      <div>
        <BackButton onClick={backStep} />
      </div>
      <span className={`bold-18 ${classes.title}`}>Detalles de cuenta de cobro</span>
      <div className={classes['box-fields']}>
        <FieldBold title='EMPRESA O SERVICIO' value={invoiceSelected.agreementName} />
        <div className={classes.fields}>
          <FieldBold title='NÚMERO DE REFERENCIA' value={invoiceSelected.number} />
          <FieldBold title='DESCRIPCIÓN DE CUENTA DE COBRO' value={invoiceSelected.description ? invoiceSelected.description : 'N/A'} />
          <FieldBold title='FECHA DE EMISIÓN' value={moment(invoiceSelected.issueDate).format('DD/MM/YYYY')} />
          <FieldBold title='TOTAL A PAGAR' value={utils.moneyFormat(invoiceSelected.valueToPay)} />
        </div>
      </div>
    </>
  );
};

export default DetailOneInvoice;
